import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const articleCards = [
  {
    slug: "dingji-wanghong-renshe-bengta",
    title: "顶流网红人设崩塌：私生活混乱遭前女友实锤曝光",
    summary: "近日，某千万粉丝级顶流网红被前女友连发多条微博实锤，曝其私下与多名女粉丝保持暧昧关系...",
    category: "wanghong",
    categoryName: "网红黑料",
    publishedAt: "2026-07-05",
    author: "吃瓜一线记者",
    views: 1285000,
    trending: true,
    featured: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20social%20media%20influencer%20drama%20atmosphere%20with%20smartphone%20showing%20leaked%20chat%20messages%20warm%20amber%20lighting%20shallow%20depth%20cinematic%20composition%20noir%20aesthetic&width=600&height=400&seq=article-card-wanghong-01&orientation=landscape",
  },
  {
    slug: "dingji-mingxing-shuiwu-weigui",
    title: "某顶级明星被曝偷税漏税逾亿元 税务部门已介入调查",
    summary: "据知情人士透露，某一线影视明星涉嫌通过阴阳合同等方式偷逃税款，涉及金额超过1.2亿元...",
    category: "mingxing",
    categoryName: "明星翻车",
    publishedAt: "2026-07-04",
    author: "深度调查组",
    views: 2350000,
    trending: true,
    featured: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20dark%20celebrity%20tax%20investigation%20concept%20with%20blurred%20luxury%20items%20and%20documents%20moody%20lighting%20cinematic%20noir%20style%20high%20contrast%20editorial%20photography&width=600&height=400&seq=article-card-mingxing-01&orientation=landscape",
  },
  {
    slug: "zhibo-daihuo-jiahuo-neimu",
    title: "直播带货翻车大揭秘：头部主播卖假货年入过亿",
    summary: "直播带货行业再曝猛料！多名头部主播被指售假，涉及化妆品、奢侈品等多个品类...",
    category: "redian",
    categoryName: "热点事件",
    publishedAt: "2026-07-03",
    author: "独家爆料组",
    views: 1890000,
    trending: true,
    featured: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20ecommerce%20scandal%20dark%20moody%20lighting%20packages%20scattered%20cinematic%20composition%20investigative%20journalism%20style%20warm%20accent&width=600&height=400&seq=article-card-redian-01&orientation=landscape",
  },
  {
    slug: "shipin-paishedao-luren-gongkai",
    title: "街拍曝光：某明星深夜与神秘女子酒店同出",
    summary: "独家视频曝光！某已婚男星深夜与妙龄女子从酒店并肩走出，举止亲密引发婚变猜测...",
    category: "shipin",
    categoryName: "视频爆料",
    publishedAt: "2026-07-05",
    author: "街拍爆料团",
    views: 4100000,
    trending: true,
    featured: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Nighttime%20street%20photography%20outside%20luxury%20hotel%20silhouettes%20dramatic%20street%20lights%20moody%20urban%20atmosphere%20paparazzi%20style%20cinematic%20noir%20high%20contrast&width=600&height=400&seq=article-card-shipin-01&orientation=landscape",
  },
  {
    slug: "nv-tuan-chengyuan-bei-ba-ling",
    title: "知名女团成员被霸凌多年 聊天记录流出引爆网络",
    summary: "某当红女团内部霸凌事件浮出水面，一名成员长期遭受队友冷暴力与言语攻击...",
    category: "bagua",
    categoryName: "娱乐八卦",
    publishedAt: "2026-07-02",
    author: "八卦特派员",
    views: 3560000,
    trending: true,
    featured: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Emotional%20moody%20K-pop%20girl%20group%20concept%20dramatic%20shadows%20silhouettes%20dark%20backstage%20tension%20cinematic%20lighting%20artistic%20composition%20contemporary%20dance%20studio&width=600&height=400&seq=article-card-bagua-01&orientation=landscape",
  },
  {
    slug: "xianggang-dingji-yiren-bei-ju-bao",
    title: "香港顶流艺人涉嫌洗钱被举报：涉案金额天文数字",
    summary: "香港娱乐圈再爆大瓜！某顶流艺人被实名举报涉嫌参与跨境洗钱活动...",
    category: "mingxing",
    categoryName: "明星翻车",
    publishedAt: "2026-06-25",
    author: "港圈特派员",
    views: 2780000,
    trending: false,
    featured: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20Hong%20Kong%20night%20scene%20financial%20district%20skyline%20luxury%20mystery%20dark%20moody%20cinematic%20reflections%20shadows%20high%20contrast%20urban%20noir&width=600&height=400&seq=article-card-mingxing-02&orientation=landscape",
  },
];

const getCategorySlug = (catId: string) => {
  return categories.find((c) => c.id === catId)?.slug || catId;
};

export default function LatestArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900">
              最新爆料
            </h2>
            <p className="mt-2 text-foreground-500 text-sm md:text-base">
              每日更新，不错过任何一个大瓜
            </p>
          </div>
          <Link
            to={`/category/${categories[0].slug}`}
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap cursor-pointer font-medium"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleCards.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  title={article.title}
                />
                {article.trending && (
                  <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium flex items-center gap-1">
                    <i className="ri-fire-line text-[10px]"></i> 热门
                  </span>
                )}
                {article.featured && (
                  <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium">
                    独家
                  </span>
                )}
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <Link
                    to={`/category/${getCategorySlug(article.category)}`}
                    className="tag-accent text-[10px] cursor-pointer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {article.categoryName}
                  </Link>
                  <span className="text-foreground-400 text-xs">{article.publishedAt}</span>
                </div>
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {article.summary}
                </p>
                <div className="flex items-center gap-3 text-foreground-400 text-xs pt-2 border-t border-background-100">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i> {article.author}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}